import React from 'react';
import { UserContext } from '..';
import { useWrapRequest } from '../../../components/hooks/use-wrap-request';
import { Api } from '../../../core/api';
import {
    UserAppInstallationSupportDto,
    UserDeviceSupportDto,
    UserPushTokenSupportDto
} from '../../../core/api/MobileClient';
import { injectTSDI } from '../../../core/tsdi';

export type {
    UserAppInstallationSupportDto,
    UserDeviceSupportDto,
    UserPushTokenSupportDto
};

export interface UserDevicesOverview {
    devices: UserDeviceSupportDto[];
    pushTokens: UserPushTokenSupportDto[];
}

export function useUserDevicesStore() {
    const { mobileClient } = injectTSDI(Api);
    const user = React.useContext(UserContext);

    const overview = useWrapRequest(
        async (userId: number): Promise<UserDevicesOverview> => {
            const [devices, pushTokens] = await Promise.all([
                mobileClient.supportApi.userDeviceSupportControllerGetUserDevices(
                    userId
                ),
                mobileClient.supportApi.userPushTokenSupportControllerGetUserPushTokens(
                    userId
                )
            ]);

            return { devices: devices.data, pushTokens: pushTokens.data };
        },
        {
            deps: [user.id]
        }
    );

    return { overview };
}
